import type { CreateTypeOfCallSopInputPrecedenceRuleDto, TypeOfCallSopInputPrecedenceRuleDto, UpdateTypeOfCallSopInputPrecedenceRuleDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { DataRequestDto, EntitySchemaDto, IdNameDto, PageRequestDto } from '../models';
import type { SopInputDto } from '../sop-inputs/models';

@Injectable({
  providedIn: 'root',
})
export class TypeOfCallSopInputPrecedenceRulesService {
  apiName = 'Default';
  

  create = (input: CreateTypeOfCallSopInputPrecedenceRuleDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TypeOfCallSopInputPrecedenceRuleDto>({
      method: 'POST',
      url: '/api/app/type-of-call-sop-input-precedence-rules',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/app/type-of-call-sop-input-precedence-rules/${id}`,
    },
    { apiName: this.apiName,...config });
  

  get = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TypeOfCallSopInputPrecedenceRuleDto>({
      method: 'GET',
      url: `/api/app/type-of-call-sop-input-precedence-rules/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getCount = (input: PageRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, number>({
      method: 'GET',
      url: '/api/app/type-of-call-sop-input-precedence-rules/count',
      params: { filter: input.filter, onlyActive: input.onlyActive, additionalData: input.additionalData, ignoreMaxResultCount: input.ignoreMaxResultCount, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getDropDownOptions = (input: DataRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<IdNameDto>>({
      method: 'GET',
      url: '/api/app/type-of-call-sop-input-precedence-rules/drop-down-options',
      params: { select: input.select, filter: input.filter, onlyActive: input.onlyActive, additionalData: input.additionalData, ignoreMaxResultCount: input.ignoreMaxResultCount, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getExpandById = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TypeOfCallSopInputPrecedenceRuleDto[]>({
      method: 'GET',
      url: `/api/app/type-of-call-sop-input-precedence-rules/${id}/expand`,
    },
    { apiName: this.apiName,...config });
  

  getExtraPropertiesById = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Record<string, object>>({
      method: 'GET',
      url: `/api/app/type-of-call-sop-input-precedence-rules/${id}/extra-properties`,
    },
    { apiName: this.apiName,...config });
  

  getIds = (input: DataRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, string[]>({
      method: 'GET',
      url: '/api/app/type-of-call-sop-input-precedence-rules/ids',
      params: { select: input.select, filter: input.filter, onlyActive: input.onlyActive, additionalData: input.additionalData, ignoreMaxResultCount: input.ignoreMaxResultCount, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getList = (input: PageRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<TypeOfCallSopInputPrecedenceRuleDto>>({
      method: 'GET',
      url: '/api/app/type-of-call-sop-input-precedence-rules',
      params: { filter: input.filter, onlyActive: input.onlyActive, additionalData: input.additionalData, ignoreMaxResultCount: input.ignoreMaxResultCount, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getOneExtraPropertiesByIdAndKey = (id: string, key: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, object>({
      method: 'GET',
      url: `/api/app/type-of-call-sop-input-precedence-rules/${id}/one-extra-properties`,
      params: { key },
    },
    { apiName: this.apiName,...config });
  

  getSchema = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, EntitySchemaDto>({
      method: 'GET',
      url: '/api/app/type-of-call-sop-input-precedence-rules/schema',
    },
    { apiName: this.apiName,...config });
  

  getSopInputs = (typeOfCallId: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SopInputDto[]>({
      method: 'GET',
      url: `/api/app/type-of-call-sop-input-precedence-rules/sop-inputs/${typeOfCallId}`,
    },
    { apiName: this.apiName,...config });
  

  getWithDetails = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TypeOfCallSopInputPrecedenceRuleDto>({
      method: 'GET',
      url: `/api/app/type-of-call-sop-input-precedence-rules/${id}/with-details`,
    },
    { apiName: this.apiName,...config });
  

  setExtraPropertiesByIdAndKeyAndValue = (id: string, key: string, value: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: `/api/app/type-of-call-sop-input-precedence-rules/${id}/set-extra-properties`,
      params: { key, value },
    },
    { apiName: this.apiName,...config });
  

  update = (id: string, input: UpdateTypeOfCallSopInputPrecedenceRuleDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TypeOfCallSopInputPrecedenceRuleDto>({
      method: 'PUT',
      url: `/api/app/type-of-call-sop-input-precedence-rules/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
